var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, entityNormalizedField, linkedMatchesFilter } from '@shapeable/utils';
import { sortBy, compact } from 'lodash';
import { useView } from '../hooks/use-view';
import { EntityFilters } from './entity-filters';
import { useOrganisationTypes } from '../hooks/use-organisation-types';
import { useTrends } from '../hooks/use-trends';
import { usePageEntity } from '../hooks/use-page-entity';
import { ExplorerEntityGridLayout } from '../explorer/explorer-entity-grid-layout';
var cls = classNames('slice-stakeholders-grid');
export var SliceStakeholdersGridDefaultProps = {
  spacing: 4
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 0;\n  "], ["\n    padding: 0;\n  "])))
});
var FiltersStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme.UNIT(3))
});
// -------- Components -------->
var My = {
  Container: styled(ExplorerEntityGridLayout)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Filters: styled(EntityFilters)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), FiltersStyles)
};
export var SliceStakeholdersGrid = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity,
    spacing = props.spacing;
  var items = __spreadArray(__spreadArray([], __read(entity.organisations), false), __read(entity.people), false);
  var hasPeople = !!(entity === null || entity === void 0 ? void 0 : entity.people.length);
  var activePage = usePageEntity();
  var view = "country-".concat(activePage.slug);
  var _a = useView(view),
    resultsFor = _a.resultsFor,
    filters = _a.filters;
  var _b = filters.types,
    types = _b === void 0 ? [] : _b,
    _c = filters.trends,
    trends = _c === void 0 ? [] : _c;
  var allOrganisationTypes = useOrganisationTypes();
  var allTrends = useTrends();
  var allPeople = sortBy(entity === null || entity === void 0 ? void 0 : entity.people, entityNormalizedField('name'));
  var allOrganisations = sortBy(entity === null || entity === void 0 ? void 0 : entity.organisations, entityNormalizedField('name'));
  var organisations = allOrganisations.filter(function (organisation) {
    return linkedMatchesFilter(compact([organisation === null || organisation === void 0 ? void 0 : organisation.type]), types) && linkedMatchesFilter(organisation === null || organisation === void 0 ? void 0 : organisation.trends, trends);
  });
  var people = allPeople.filter(function (person) {
    return linkedMatchesFilter(person === null || person === void 0 ? void 0 : person.trends, trends) && linkedMatchesFilter(compact([person === null || person === void 0 ? void 0 : person.type]), types);
  });
  var stakeholders = sortBy(__spreadArray(__spreadArray([], __read(resultsFor({
    type: 'Organisation',
    data: organisations,
    by: 'name'
  })), false), __read(resultsFor({
    type: 'Person',
    data: people,
    by: 'name'
  })), false), 'name');
  return React.createElement(My.Container, {
    className: cls.name(className),
    view: view,
    isExplorer: false,
    filters: !!items.length && React.createElement(My.Filters, __assign({
      view: view,
      results: __spreadArray(__spreadArray([], __read(organisations), false), __read(people), false),
      selects: compact([{
        name: 'types',
        items: allOrganisationTypes,
        pluralLabel: 'Stakeholder Types',
        getResultFieldSlugs: function (result) {
          var _a;
          return [(_a = result.type) === null || _a === void 0 ? void 0 : _a.slug];
        }
      }, {
        name: 'trends',
        items: allTrends,
        pluralLabel: 'Innovation Systems',
        getResultFieldSlugs: function (result) {
          var _a;
          return (_a = result.trends) === null || _a === void 0 ? void 0 : _a.map(function (trend) {
            return trend === null || trend === void 0 ? void 0 : trend.slug;
          });
        }
      }])
    }, hasPeople && {
      typeToggles: compact([{
        name: 'Organisation',
        label: 'Organisations'
      }, {
        name: 'Person',
        label: 'People'
      }])
    })),
    items: stakeholders
  });
};
SliceStakeholdersGrid.defaultProps = SliceStakeholdersGridDefaultProps;
SliceStakeholdersGrid.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;